import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import FeaturedProgramsData from "../../data/FeaturedProgramsData.json";
import { Pagination, Stack } from "@mui/material";
import { allowedPeople, baseUrl } from "../../Constants";
import { Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import AddFeaturedProgram from "../AddEventFolder/AddFeaturedProgram";

function FeaturedProgramSection() {
  const [currentPage, setCurrentPage] = useState(1);
  const [addFeaturePopup, setaddFeaturePopup] = useState(false);
  const [FeaturedProgState, setFeaturedProgState] = useState([]);
  const [confirmatuinPopup, setconfirmatuinPopup] = useState(false);
  const [itemsToDelete, setitemsToDelete] = useState();
  const [editItem, seteditItem] = useState();
  const itemsPerPage = 6;

  //   const totalPages = Math.ceil(FeaturedProgramsData.length / itemsPerPage);
  const totalPages = Math.ceil(FeaturedProgState.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = FeaturedProgramsData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  //fetching User

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const getItemWithId = (id) => {
    axios
      .get(`${baseUrl}/getfeaturedprog`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const ar = response.data.results;
        return ar ? ar.find((item) => item.id === id) : null;

        // setFeaturedProgState(response.data.results);
        console.log("getFeatureResponse", response);
      })
      .catch((error) => {
        console.log(error);
        console.log("getFeatureResponse", error);
      });
  };

  const deleteItem = async (id) => {
    try {
      const res = await axios.post(
        `${baseUrl}/deletefeaturedprog`,
        { id },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
      getFeaturedProg();
    } catch (err) {
      console.error(err);
    }
  };

  const getFeaturedProg = () => {
    axios
      .get(`${baseUrl}/getfeaturedprog`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setFeaturedProgState(response.data.results); // Set the data
        console.log("getFeatureResponse", response);
      })
      .catch((error) => {
        console.log(error);
        console.log("getFeatureResponse", error);
      });
  };

  // useEffect(() => {
  //   setaddFeaturePopup(true);
  // }, [editItem])

  useEffect(() => {
    console.log("workinggg....");

    getFeaturedProg();
  }, [addFeaturePopup]);

  return (
    <>
      <div className="featured-programs-new-wrap wrap1">
        <div style={{ display: "flex", flexDirection: "column" }}>
          <h2 className="main-headings">Featured Programs</h2>
          {allowedPeople.includes(loggedInEnterpriseId) && (
            <button
              type="button"
              onClick={() => {
                seteditItem(null);
                setaddFeaturePopup(true);
              }}
              className="add-prog-button feat-add"
            >
              <AddIcon />
              Add Program
            </button>
          )}
        </div>
        <p className="featured-subtext">
          A selection of top-tier learning programs designed to keep you in pace
          with the evolving technology landscape.
        </p>
        {/* Custom Pagination Section */}
        {totalPages > 1 && (
          <div className="custom-pagination-wrapper">
            <button
              className="arrow-button"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              aria-label="Previous page"
            >
              <FaArrowLeft />
            </button>
            <div className="custom-pagination-dots">
              {Array.from({ length: totalPages }).map((_, index) => (
                <span
                  key={index}
                  onClick={() => setCurrentPage(index + 1)}
                  className={`dot ${currentPage === index + 1 ? "active" : ""}`}
                  role="button"
                  tabIndex={0}
                  aria-label={`Go to page ${index + 1}`}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      setCurrentPage(index + 1);
                    }
                  }}
                />
              ))}
            </div>
            <button
              className="arrow-button"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              aria-label="Next page"
            >
              <FaArrowRight />
            </button>
          </div>
        )}
      </div>
      <div className="featured-programs-new-wrap wrap2">
        <div className="featured-programs-grid">
          {/* {currentItems.map((item) => ( */}
          {FeaturedProgState &&
            FeaturedProgState.slice(indexOfFirstItem, indexOfLastItem).map(
              (item) => (
                <div
                  className="featured-program-card"
                  key={item.id}
                  // data-aos="zoom-in-up"
                >
                  <img
                    src={item.featuredicon}
                    alt="program"
                    className="program-image"
                  />
                  <div className="program-content">
                    <h3 className="program-title">{item.title}</h3>
                    <p className="program-desc">{item.description}</p>

                    <div
                      style={{
                        alignItems: "center",
                        position: "absolute",
                        bottom: "-10px",
                        width: "60%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <a
                          href={item.know_more_url}
                          target="_blank"
                          className="program-link"
                        >
                          Know more...
                        </a>
                        {allowedPeople.includes(loggedInEnterpriseId) && (
                          <div
                            className="edit-delete-box"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {/* <EditNoteRoundedIcon
                              sx={{
                                color: "gray",
                                display: "inline",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                seteditItem(item);
                                setaddFeaturePopup(true);
                              }}
                            /> */}
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/Home/edit-icon.png"
                              }
                              alt="icon"
                              className="edit-delete-icons"
                              onClick={() => {
                                seteditItem(item);
                                setaddFeaturePopup(true);
                              }}
                            />
                            {/* <DeleteRoundedIcon
                              sx={{
                                color: "gray",
                                display: "inline",
                                cursor: "pointer",
                                width: "0.8em",
                                height: "0.8em",
                              }}
                              onClick={() => {
                                setconfirmatuinPopup(true);
                                setitemsToDelete(item.id);
                                setCurrentPage(1);
                              }}
                            /> */}
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/Home/delete-icon.png"
                              }
                              alt="icon"
                              className="edit-delete-icons"
                              onClick={() => {
                                setconfirmatuinPopup(true);
                                setitemsToDelete(item.id);
                                setCurrentPage(1);
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    {/* <a href={item.know_more_url} className="program-link">
                        Know more...
                      </a>
                    {
              (allowedPeople.includes(loggedInEnterpriseId)) &&
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <EditNoteRoundedIcon sx={{ color: 'gray', display: 'inline', cursor: 'pointer' }} onClick={() => {seteditItem(item); setaddFeaturePopup(true);}}/>
                    <DeleteRoundedIcon sx={{ color: 'gray', display: 'inline', cursor: 'pointer', width: "0.8em", height: "0.8em"}} onClick={() => {setconfirmatuinPopup(true); setitemsToDelete(item.id); setCurrentPage(1)}}/>
                    </div>
                    }      */}
                  </div>
                </div>
              )
            )}
        </div>
      </div>

      {/* Full-Screen Popup Modal */}
      {addFeaturePopup && (
        <div className="fullscreen-popup">
          {/* <div className="popup-content"> */}

          {console.log("edititem", editItem)}
          <AddFeaturedProgram
            item={editItem ? editItem : null}
            setaddFeaturePopup={setaddFeaturePopup}
            getFeaturedProg={getFeaturedProg}
          />

          {/* <Link to="/response" className="confirm" onClick={confirmSubmit}>Yes, Submit</Link>
                  <button className="cancel" onClick={closePopup}>Cancel</button> */}
          {/* </div> */}
        </div>
      )}

      {/* Full-Screen Popup Modal */}
      {confirmatuinPopup && (
        <div className="fullscreen-popup">
          <div className="popup-content">
            <div className="questions">Are you sure you want to submit?</div>
            <p>Once submitted, you cannot change your answers.</p>
            <div className="popup-buttons">
              <button
                className="confirm"
                onClick={() => {
                  deleteItem(itemsToDelete);
                  setconfirmatuinPopup(false);
                }}
              >
                Yes, delete!
              </button>
              <button
                className="cancel"
                onClick={() => setconfirmatuinPopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FeaturedProgramSection;
